/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Filter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Filter 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M16 3a4.002 4.002 0 0 1 3.874 3H21a1 1 0 1 1 0 2h-1.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1 0-2h9.126c.444-1.725 2.01-3 3.874-3Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2 17a1 1 0 0 0 1 1h1.126a4.002 4.002 0 0 0 7.748 0H21a1 1 0 1 0 0-2h-9.126a4.002 4.002 0 0 0-7.748 0H3a1 1 0 0 0-1 1Zm8 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const FilterIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'filter-icon'}
      icon={Filter}
      {...props}
      size={size}
    />
  );
};
